module.exports = __webpack_public_path__ + "e81aadea85b4ce8373874bb2676b3f40.svg";